import React from "react";
import {
    Box,
    Container,
    Typography,
    IconButton,
} from "@mui/material";
import { Link } from "react-router-dom";
import { FaInstagram, FaWhatsapp, FaFacebookF } from "react-icons/fa";

const footerLinkStyles = {
    display: "block",
    opacity: 0.8,
    mb: 1,
    textDecoration: "none",
    color: "inherit",
    transition: "0.2s",
    "&:hover": {
        opacity: 1,
        textDecoration: "underline",
    },
};

const Footer = () => {
    return (
        <Box
            component="footer"
            sx={{
                backgroundColor: "var(--azul)",
                color: "white",
                mt: 0,
                pt: 10,
                pb: 4,
            }}
        >
            <Container maxWidth="xl">
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        gap: 6,
                    }}
                >
                    <Box sx={{ flex: { md: 1 }, maxWidth: { md: 1020 } }}>
                        <Typography
                            sx={{
                                fontSize: 28,
                                fontWeight: 800,
                                letterSpacing: 1,
                                mb: 2,
                            }}
                        >
                            EMMA
                        </Typography>

                        <Typography sx={{ opacity: 0.85, lineHeight: 1.6, width: { xs: "100%", md: "50%" } }}>
                            Sabor, inovação e tecnologia. A EMMA eleva a acessibilidade de Pods e Vapes no Brasil — uma experiência positiva desde a primeira compra, para te inicializar na nossa família.
                        </Typography>
                    </Box>

                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: { xs: "flex-start", md: "flex-end" },
                            alignItems: "flex-start",
                            gap: { xs: 4, md: 8 },
                            flexWrap: "wrap",
                            ml: { md: "auto" },
                        }}
                    >
                        <Box sx={{ minWidth: { xs: "auto", md: 180 } }}>
                            <Typography sx={{ fontWeight: 700, mb: 2 }}>Institucional</Typography>

                            {[
                                { label: "Home", path: "/" },
                                { label: "Produtos", path: "/produtos" },
                                { label: "Sobre", path: "/sobre" },
                                { label: "Contato", path: "/contato" },
                                { label: "Minha Conta", path: "/minha-conta" },
                            ].map((item) => (
                                <Typography
                                    key={item.label}
                                    component={Link}
                                    to={item.path}
                                    sx={footerLinkStyles}
                                >
                                    {item.label}
                                </Typography>
                            ))}
                        </Box>

                        <Box sx={{ minWidth: { xs: "auto", md: 180 } }}>
                            <Typography sx={{ fontWeight: 700, mb: 2 }}>Suporte</Typography>

                            {[
                                { label: "Política de Trocas", path: "/politica-trocas" },
                                { label: "Privacidade", path: "/privacidade" },
                                { label: "Ajuda", path: "/ajuda" },
                            ].map((item) => (
                                <Typography
                                    key={item.label}
                                    component={Link}
                                    to={item.path}
                                    sx={footerLinkStyles}
                                >
                                    {item.label}
                                </Typography>
                            ))}
                        </Box>
                    </Box>
                </Box>

                <Box
                    sx={{
                        width: "100%",
                        height: "1px",
                        backgroundColor: "rgba(255,255,255,0.15)",
                        my: 5,
                    }}
                />

                <Box
                    sx={{
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 3,
                    }}
                >
                    <Box sx={{ display: "flex", gap: 2 }}>
                        {[
                            {
                                Icon: FaInstagram,
                                href: "https://www.instagram.com/emma.podss/",
                                label: "Instagram",
                            },
                            {
                                Icon: FaWhatsapp,
                                href: "https://wa.me/5531981020410?text=Ol%C3%A1!%20Vim%20diretamente%20do%20site%20para%20obter%20mais%20informa%C3%A7%C3%B5es!%20%F0%9F%98%8A",
                                label: "WhatsApp",
                            },
                            {
                                Icon: FaFacebookF,
                                href: "https://www.facebook.com/profile.php?id=61571317257456&locale=pt_BR",
                                label: "Facebook",
                            },
                        ].map(({ Icon, href, label }) => (
                            <IconButton
                                key={label}
                                component="a"
                                href={href}
                                target="_blank"
                                rel="noreferrer"
                                aria-label={label}
                                sx={{
                                    color: "white",
                                    backgroundColor: "rgba(255,255,255,0.08)",
                                    "&:hover": {
                                        backgroundColor: "rgba(255,255,255,0.2)",
                                    },
                                }}
                            >
                                <Icon size={20} />
                            </IconButton>
                        ))}
                    </Box>

                    <Typography sx={{ opacity: 0.7, textAlign: "center" }}>
                        © {new Date().getFullYear()} EMMA Pods — Todos os direitos reservados.
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;
